import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../../booking/api";
import { Button } from "../../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../components/ui/dialog";

export function useEntity(entity) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(() => {
    api.get(`/api/admin/${entity}`)
      .then((r) => setItems(r.data))
      .catch((e) => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, [entity]);

  useEffect(() => { reload(); }, [reload]);

  const save = async (draft) => {
    try {
      if (draft.id) await api.put(`/api/admin/${entity}/${draft.id}`, draft);
      else await api.post(`/api/admin/${entity}`, draft);
      toast.success("Saved");
      reload();
      return true;
    } catch (e) {
      toast.error(formatApiError(e));
      return false;
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/api/admin/${entity}/${id}`);
      toast.success("Deleted");
      reload();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return { items, loading, save, remove, reload };
}

export const EditDialog = ({ open, onClose, title, onSave, children, saving }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-w-xl max-h-[85vh] overflow-y-auto">
      <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
      <div className="space-y-4 py-2">{children}</div>
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Cancel</Button>
        <Button data-testid="entity-save-btn" onClick={onSave} disabled={saving}>Save</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const Field = ({ label, children }) => (
  <div>
    <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{label}</label>
    <div className="mt-1">{children}</div>
  </div>
);
